import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IConnectionsDAO } from '../../../../api/connections.dao';

export class DeleteUniqueJoiningLinksJob extends JobConfiguration {
    public readonly type = JobType.DeleteUniqueJoiningLinks;
    public readonly name = 'Delete Unique Joining Links';
    public readonly description = 'Link deletion';

    public async execute(execParams) {
        return IoC.Container.get(IConnectionsDAO).deleteUniqueJoiningLinksConnections(execParams);
    }
}

export default {
    [JobType.DeleteUniqueJoiningLinks]: DeleteUniqueJoiningLinksJob
};